
import BranchDto from '@/models/Branches/BranchDto';
import DeskDto from '@/models/Desks/DeskDto';
import ListUtils from '@/lib/listUtils';
import CampaignStatus from '@/models/Campaigns/CampaignStatus';
import EmailTemplateDto from '@/models/EmailTemplates/EmailTemplateDto';
import CampaignStatusViewModel from '@/models/Campaigns/CampaignStatusViewModel';
import AgencyUserDto from '../AgencyUsers/AgencyUserDto';

export default class CurrentCampaignSearchCriteria {
    selectedEmailTemplate: EmailTemplateDto;
    selectedBranch: BranchDto;
    selectedDesk: DeskDto;
    selectedOwner: AgencyUserDto = null;
    selectedStatus: CampaignStatus = CampaignStatus.Active;
}